/*
 * Module Comment
*/

rs.module("user/account/login",

    ["ui/framework/passkeys"],

    function (passkeys) {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, returnUrl) {

            var loginErrorDiv = $.js(jsSelectors.jsLoginErrors);
            var loginDialog = $.js(jsSelectors.loginDialog);

            // Initialize passkey registration flow
            passkeys.initializeLogin({
                loginButton: jsSelectors.passkeyLoginButton,
                rememberMe: jsSelectors.rememberMe
            },
                backendUrls,
                returnUrl,
                onLoginError,
                onPasswordlessStart,
                onPasswordlessComplete
            );

            // Callback for when a passwordless authentication ceremony begins
            function onPasswordlessStart() {
                // disable login controls
                loginDialog.find(":input").setDisabled();
                loginDialog.find(":button").setDisabled();
            }

            // Callback for when a passwordless authentication ceremony ends
            function onPasswordlessComplete() {
                // enable login controls
                loginDialog.find(":input").setDisabled(false);
                loginDialog.find(":button").setDisabled(false);
            }
              
            // Handles login failures
            function onLoginError(error) {
                // clear any existing model errors which may exist
                $(".validation-summary-errors").html("");

                if (error) {
                    // add errors to our validation summary 
                    loginErrorDiv.html("<ul><li>" + error + "</li></ul>");

                    // show the validation summary
                    loginErrorDiv.show();
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);